export default "__VITE_ASSET__BHLSatgA__"